import React from 'react';

// project improts
import useConfig from 'hooks/useConfig';

// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone';
import { ThemeProvider, createTheme, bgcolor } from '@mui/system';
import useAuth from 'hooks/useAuth';
import {
    BadgeOutlined,
    ClassOutlined,
    CurrencyRupeeOutlined,
    InventoryOutlined,
    RateReviewOutlined,
    SupervisorAccountOutlined,
    CalendarMonthOutlined,
    AddCircle,
    AddTask,
    Security,
    AccountBalanceWallet,
    AutoStories,
    BorderColor,
    Wysiwyg,
    ForkRight,
    DirectionsBus,
    Videocam,
    HomeWork,
    DirectionsWalk,
    DepartureBoard,
    Storefront,
    Download,
    MoneyOff
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'store';
import { setSelectedMobileMenuItem } from 'store/slices/common';
import { FormattedMessage } from 'react-intl';

// ================================|| UI LIST - SELECTED LIST ||================================ //

const theme = createTheme({
    palette: {
        background: {
            paper: '#fff'
        },
        text: {
            primary: '#173A5E',
            secondary: '#46505A'
        },
        action: {
            active: '#001E3C'
        },
        success: {
            dark: '#009688'
        }
    }
});

const listTextColor = {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: 'white',
    fontFamily: 'Roboto,sans-serif',
    textAlign: 'center'
};

export default function SelectedListItem({ handleTooltipOpen }) {
    const { defaultRole } = useAuth();
    const { borderRadius } = useConfig();
    const { selectedMobileMenuItem } = useSelector((state) => state.common);
    const dispatch = useDispatch();

    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const handleListItemClick = (event, index) => {
        // setSelectedIndex(index);
        dispatch(setSelectedMobileMenuItem(index));
        handleTooltipOpen();
    };

    const itemTarget = '_self';
    const listItemProps = (link) => ({
        component: React.forwardRef((props, ref) => <Link ref={ref} {...props} to={link} target={itemTarget} />)
    });

    const managementList = () => (
        <>
            <ListItemButton
                {...listItemProps('/parents')}
                selected={selectedMobileMenuItem === 0}
                onClick={(event) => handleListItemClick(event, 0)}
            >
                <ListItemIcon>
                    <ClassOutlined />
                </ListItemIcon>
                <ListItemText primary="Parents" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/teachers')}
                selected={selectedMobileMenuItem === 1}
                onClick={(event) => handleListItemClick(event, 1)}
            >
                <ListItemIcon>
                    <SupervisorAccountOutlined />
                </ListItemIcon>
                <ListItemText primary="Teachers" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/exams')}
                selected={selectedMobileMenuItem === 2}
                onClick={(event) => handleListItemClick(event, 2)}
            >
                <ListItemIcon>
                    <RateReviewOutlined />
                </ListItemIcon>
                <ListItemText primary="Exams" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/results')}
                selected={selectedMobileMenuItem === 3}
                onClick={(event) => handleListItemClick(event, 3)}
            >
                <ListItemIcon>
                    <InventoryOutlined />
                </ListItemIcon>
                <ListItemText primary="Results" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/staffs')}
                selected={selectedMobileMenuItem === 4}
                onClick={(event) => handleListItemClick(event, 4)}
            >
                <ListItemIcon>
                    <BadgeOutlined />
                </ListItemIcon>
                <ListItemText primary="Staffs" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/attendance')}
                selected={selectedMobileMenuItem === 5}
                onClick={(event) => handleListItemClick(event, 5)}
            >
                <ListItemIcon>
                    <CalendarMonthOutlined />
                </ListItemIcon>
                <ListItemText primary="Attendance" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/stationery')}
                selected={selectedMobileMenuItem === 15}
                onClick={(event) => handleListItemClick(event, 15)}
            >
                <ListItemIcon>
                    <Storefront />
                </ListItemIcon>
                <ListItemText primary="Stationery" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/permission')}
                selected={selectedMobileMenuItem === 8}
                onClick={(event) => handleListItemClick(event, 8)}
            >
                <ListItemIcon>
                    <Security />
                </ListItemIcon>
                <ListItemText primary="Permission" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/recharge')}
                selected={selectedMobileMenuItem === 9}
                onClick={(event) => handleListItemClick(event, 9)}
            >
                <ListItemIcon>
                    <AccountBalanceWallet />
                </ListItemIcon>
                <ListItemText primary="Recharge" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/template')}
                selected={selectedMobileMenuItem === 10}
                onClick={(event) => handleListItemClick(event, 10)}
            >
                <ListItemIcon>
                    <Wysiwyg />
                </ListItemIcon>
                <ListItemText primary="Template" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/vehicle-routes')}
                selected={selectedMobileMenuItem === 11}
                onClick={(event) => handleListItemClick(event, 11)}
            >
                <ListItemIcon>
                    <ForkRight />
                </ListItemIcon>
                <ListItemText primary="Routes" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/vehicles')}
                selected={selectedMobileMenuItem === 12}
                onClick={(event) => handleListItemClick(event, 12)}
            >
                <ListItemIcon>
                    <DirectionsBus />
                </ListItemIcon>
                <ListItemText primary="Vehicles" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/vehicle-reports')}
                selected={selectedMobileMenuItem === 14}
                onClick={(event) => handleListItemClick(event, 14)}
            >
                <ListItemIcon>
                    <DepartureBoard />
                </ListItemIcon>
                <ListItemText primary="Vehicle Reports" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/visitors')}
                selected={selectedMobileMenuItem === 13}
                onClick={(event) => handleListItemClick(event, 13)}
            >
                <ListItemIcon>
                    <DirectionsWalk />
                </ListItemIcon>
                <ListItemText primary="Visitors" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/new-record')}
                selected={selectedMobileMenuItem === 6}
                onClick={(event) => handleListItemClick(event, 6)}
            >
                <ListItemIcon>
                    <AddCircle />
                </ListItemIcon>
                <ListItemText primary="New Record" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/update-record')}
                selected={selectedMobileMenuItem === 7}
                onClick={(event) => handleListItemClick(event, 7)}
            >
                <ListItemIcon>
                    <AddTask />
                </ListItemIcon>
                <ListItemText primary="Update Record" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/download')}
                selected={selectedMobileMenuItem === 16}
                onClick={(event) => handleListItemClick(event, 16)}
            >
                <ListItemIcon>
                    <Download />
                </ListItemIcon>
                <ListItemText primary="Download" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/not-fees-students')}
                selected={selectedMobileMenuItem === 17}
                onClick={(event) => handleListItemClick(event, 17)}
            >
                <ListItemIcon>
                    <MoneyOff />
                </ListItemIcon>
                <ListItemText primary="Not Fees" />
            </ListItemButton>
        </>
    );

    const studentList = () => (
        <>
            <ListItemButton
                {...listItemProps('/exam')}
                selected={selectedMobileMenuItem === 0}
                onClick={(event) => handleListItemClick(event, 0)}
            >
                <ListItemIcon>
                    <RateReviewOutlined />
                </ListItemIcon>
                <ListItemText primary="Exams" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/result')}
                selected={selectedMobileMenuItem === 1}
                onClick={(event) => handleListItemClick(event, 1)}
            >
                <ListItemIcon>
                    <InventoryOutlined />
                </ListItemIcon>
                <ListItemText primary="Results" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/fees')}
                selected={selectedMobileMenuItem === 2}
                onClick={(event) => handleListItemClick(event, 2)}
            >
                <ListItemIcon>
                    <CurrencyRupeeOutlined />
                </ListItemIcon>
                <ListItemText primary="Fees" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/subjects')}
                selected={selectedMobileMenuItem === 3}
                onClick={(event) => handleListItemClick(event, 3)}
            >
                <ListItemIcon>
                    <AutoStories />
                </ListItemIcon>
                <ListItemText primary="Subjects" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/onlineclasses')}
                selected={selectedMobileMenuItem === 4}
                onClick={(event) => handleListItemClick(event, 4)}
            >
                <ListItemIcon>
                    <Videocam />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="onlineclasses" />} />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/homework')}
                selected={selectedMobileMenuItem === 5}
                onClick={(event) => handleListItemClick(event, 5)}
            >
                <ListItemIcon>
                    <HomeWork />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="homework" />} />
            </ListItemButton>
        </>
    );

    const teacherList = () => (
        <>
            <ListItemButton
                {...listItemProps('/exams')}
                selected={selectedMobileMenuItem === 0}
                onClick={(event) => handleListItemClick(event, 0)}
            >
                <ListItemIcon>
                    <RateReviewOutlined />
                </ListItemIcon>
                <ListItemText primary="Exams" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/results')}
                selected={selectedMobileMenuItem === 1}
                onClick={(event) => handleListItemClick(event, 1)}
            >
                <ListItemIcon>
                    <InventoryOutlined />
                </ListItemIcon>
                <ListItemText primary="Results" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/fees')}
                selected={selectedMobileMenuItem === 2}
                onClick={(event) => handleListItemClick(event, 2)}
            >
                <ListItemIcon>
                    <CurrencyRupeeOutlined />
                </ListItemIcon>
                <ListItemText primary="Fees" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/subjects')}
                selected={selectedMobileMenuItem === 3}
                onClick={(event) => handleListItemClick(event, 3)}
            >
                <ListItemIcon>
                    <AutoStories />
                </ListItemIcon>
                <ListItemText primary="Subjects" />
            </ListItemButton>
            <ListItemButton
                {...listItemProps('/teachings')}
                selected={selectedMobileMenuItem === 4}
                onClick={(event) => handleListItemClick(event, 4)}
            >
                <ListItemIcon>
                    <BorderColor />
                </ListItemIcon>
                <ListItemText primary="Teachings" />
            </ListItemButton>
        </>
    );

    return (
        <List
            sx={{
                maxHeight: 300,
                overflow: 'hidden',
                overflowY: 'scroll',
                p: 0,
                '& .MuiListItemButton-root:nth-child(1)': { mt: 0 },
                '& .MuiListItemButton-root': {
                    // bgcolor: '#1c5694',
                    bgcolor: '#3F51B5',
                    p: 0.35,
                    mt: '7px',
                    // borderRadius: `${borderRadius}px`,
                    borderRadius: `2px`,
                    ':hover': {
                        // bgcolor: '#c8deec',
                        bgcolor: '#bdc3e8',
                        '.MuiListItemIcon-root .MuiSvgIcon-root': {
                            // color: '#1c5694',
                            color: '#3F51B5',
                            fontSize: 24,
                            pl: 0.3
                        },
                        '.MuiListItemText-primary': {
                            // color: '#1c5694'
                            color: '#3F51B5'
                        }
                    },
                    '&.Mui-selected': {
                        ':hover': {
                            // bgcolor: '#c8deec'
                            bgcolor: '#bdc3e8'
                        },
                        // bgcolor: '#c8deec',
                        bgcolor: '#bdc3e8',
                        '.MuiListItemText-primary': {
                            // color: '#1c5694'
                            color: '#3F51B5'
                        },
                        '.MuiListItemIcon-root .MuiSvgIcon-root': {
                            // color: '#1c5694'
                            color: '#3F51B5'
                        }
                    },
                    '.MuiListItemText-primary': {
                        color: 'white'
                    },
                    '.MuiListItemIcon-root .MuiSvgIcon-root': {
                        color: 'white',
                        fontSize: 24,
                        pl: 0.3
                    },
                    '.MuiListItemIcon-root': {
                        minWidth: 28
                    }
                }
            }}
        >
            {defaultRole === 'managment' && managementList()}
            {defaultRole === 'teacher' && teacherList()}
            {defaultRole === 'student' && studentList()}
            {/* <ListItemButton selected={selectedMobileMenuItem === 0} onClick={(event) => handleListItemClick(event, 0)}>
                <ListItemIcon>
                    <HomeTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Sample Page" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 1} onClick={(event) => handleListItemClick(event, 1)}>
                <ListItemIcon>
                    <DescriptionTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Elements" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 2} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton> */}
            {/* <ListItemButton selected={selectedMobileMenuItem === 3} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 4} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 5} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 3} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 4} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 5} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 3} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 4} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 5} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 3} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 4} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton>
            <ListItemButton selected={selectedMobileMenuItem === 5} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <ListAltTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Page Layouts" />
            </ListItemButton> */}
        </List>
    );
}
